//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    bindPhoneNumber: null
  },
  mounted: function mounted() {
    document.body.style.overflow = 'hidden';
  },
  destroyed: function destroyed() {
    document.body.style.overflow = 'initial';
  },
  methods: {
    // 关闭模态窗
    closeModal: function closeModal() {
      this.$emit('closeEvent');
    }
  }
};